import type { RouteLocationRaw } from 'vue-router'

export type NavbarBreadcrumb = {
  label: string
  to?: RouteLocationRaw
}

export type NavbarBreadcrumbState = {
  sourcePath: string
  items: NavbarBreadcrumb[]
}

export const useNavbarBreadcrumbs = () =>
  useState<NavbarBreadcrumbState>('navbarBreadcrumbs', () => ({
    sourcePath: '',
    items: [],
  }))
